/**
 * The Flexi Directory path for a Console path under /users (FNP-2017).
 * Directory mounts its users module at the same paths, except that it has no
 * /users/add page: a person is added from the New User drawer on the list, so
 * /users/add maps to the list rather than to a user whose id is "add".
 */
export const directoryPathFor = (pathname: string): string =>
    /^\/users\/add\/?$/.test(pathname) ? '/users' : pathname;
